import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../css/new-mail/Mail.css";

const Mail = () => {
  const navigate = useNavigate();

  return (
    <div className="new-mail">
      <div className="mail-container">
        <div className="mail-header">
          <div className="mail-header-left">
            <div className="type">Type</div>
            <span>*</span>
          </div>
          <div className="mail-header-right">
            <div className="home">ff</div>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                stroke="#949494"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M 4.5 6.75 L 9 11.25 L 13.5 6.75"></path>
              </svg>
            </div>
          </div>
        </div>

        <div className="mail-bottom">
          <div className="part1">
            <div className="section1">
              <div className="left">
                <div className="left-top">
                  <div className="header">
                    <div className="to">To</div>
                    <div className="arrow">
                      <div className="home">gg</div>
                      <div>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          stroke="#949494"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M 4.5 6.75 L 9 11.25 L 13.5 6.75"></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="box">
                    <div className="hard-copy">HARD COPY</div>
                    <div className="remove">REMOVE</div>
                  </div>
                </div>
                <div className="left-bottom">
                  <div className="cc">CC</div>
                  <div className="bcc">BCC</div>
                  </div>
              </div>
              <div className="directory">Directory</div>
            </div>
          </div>
          <div className="part2">4</div>
        </div>
      </div>
    </div>
  );
};

export default Mail;
